
import * as handlebars_family from "../handlebars_family.ts";
import "../widget/onoff.mustache";
const TPL = handlebars_family.addTemplate("settings/edit_family_administrator",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"settings.admin_information_label",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":91},"end":{"line":1,"column":136}}})) != null ? stack1 : "")
    + " ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"settings.nonadmin_information_label",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":146},"end":{"line":1,"column":194}}})) != null ? stack1 : "")
    + " ";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow style=\"margin:16px 0\" data-fw-meta-id="
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"accountId") : depth0), depth0))
    + "><img class=\"fw-avatar fw-avatar-sizeL\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"thumb") : depth0), depth0))
    + "\"/><flexauto style=\"margin-left:16px\"><div class=\"fw-text-ellipsis\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</div> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isAdmin") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":1,"column":424},"end":{"line":1,"column":618}}})) != null ? stack1 : "")
    + " </flexauto> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"widget/onoff"),depth0,{"name":"widget/onoff","hash":{"onchange":"adminchangeright","disabled":(depth0 != null ? lookupProperty(depth0,"isAdminEditableDisabled") : depth0),"value":(depth0 != null ? lookupProperty(depth0,"isAdmin") : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </flexrow> ";
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span class=\"small fw-background-branded\" style=\"border-radius:8px;line-height:16px;padding:0px 8px\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"roleText") : depth0), depth0))
    + "</span> ";
},"8":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"sub2\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"roleText") : depth0), depth0))
    + "</div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<div><h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"settings.admin_information",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":9},"end":{"line":1,"column":48}}})) != null ? stack1 : "")
    + "</h1><p class=\"sub2\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"user") : depth0)) != null ? lookupProperty(stack1,"isAdmin") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":70},"end":{"line":1,"column":202}}})) != null ? stack1 : "")
    + " </p> ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"members") || (depth0 != null ? lookupProperty(depth0,"members") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"members","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":208},"end":{"line":1,"column":747}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"members")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " </div> ";
},"usePartial":true,"useData":true});
export default TPL;